{/* Auto-generated icon - do not edit */}
import React from 'react'

interface YCombinatorIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const YCombinatorIcon = React.forwardRef<SVGSVGElement, YCombinatorIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 81 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M78.4815 1.05615C77.8987 0.642086 77.2174 0.389162 76.5059 0.322896C75.7938 0.25663 75.0777 0.379563 74.4286 0.678947C73.4093 1.15159 72.5371 1.89236 71.9057 2.82198C64.3853 13.3799 56.5342 24.4679 48.5702 35.7799C46.7711 38.3343 45.0259 40.9143 43.1705 43.6454C42.4551 44.7016 41.7217 45.7817 40.9704 46.8857C40.503 46.3272 40.0482 45.791 39.6052 45.2692C38.3581 43.799 37.1767 42.4101 36.12 40.978C33.1592 36.9743 30.1756 32.8848 27.2897 28.9297C24.4549 25.0448 21.5243 21.0279 18.6167 17.0945C15.2517 12.5414 11.8126 8.03713 8.395 3.70137C6.70424 1.55777 4.4032 0.948166 2.53264 2.15058C0.715239 3.3182 0.439513 5.61989 1.8106 8.15731C2.77341 9.96755 3.86368 11.7069 5.07323 13.3625C8.55705 18.0546 11.9983 22.905 15.3259 27.5952C21.7016 36.5805 28.2945 45.8731 35.4952 54.4961C36.3646 55.4641 36.8476 56.718 36.8519 58.0191C36.8896 59.7474 36.9229 61.4761 36.9523 63.2044C37.0737 69.8991 37.1998 76.8188 37.6467 83.6119C38.1521 91.2996 39.0907 98.7733 40.1828 107.047C40.4926 109.147 41.3129 111.138 42.5718 112.847C42.9958 113.447 43.555 113.939 44.2043 114.284C44.8536 114.628 45.5749 114.814 46.3097 114.829C46.5192 114.829 46.7284 114.814 46.9357 114.783C47.7919 114.638 48.5923 114.263 49.2499 113.696C49.9075 113.129 50.3972 112.392 50.6658 111.567C51.227 109.994 51.4104 108.313 51.2013 106.657C48.8122 88.7898 47.8376 70.7786 47.2548 57.0833C47.1693 55.5412 47.6055 54.0152 48.4932 52.7514C49.956 50.5487 51.4086 48.339 52.8508 46.1223C55.1683 42.5781 57.5646 38.9125 59.9885 35.3584C63.0608 30.8533 66.2237 26.3009 69.2803 21.8936C72.1964 17.693 75.2116 13.3481 78.1455 9.05301C79.0479 7.78969 79.6452 6.33469 79.892 4.80189C80.0127 4.10848 79.9451 3.39572 79.697 2.73705C79.449 2.07839 79.0296 1.49781 78.4815 1.05615Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="80.0732" height="114.859" fill={color} transform="translate(0.415405 0.21582)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

YCombinatorIcon.displayName = 'YCombinatorIcon'
